import Api from "~/service/Api";

class AwsS3UploadSignedUrlRepository {
  fetchOne(query) {
    return Api.get("/aws-s3/upload/signed-urls", query);
  }
}

export default AwsS3UploadSignedUrlRepository;
